import { render, staticRenderFns } from "./GestioneAccount.vue?vue&type=template&id=f8ec9ce4&"
import script from "./GestioneAccount.vue?vue&type=script&lang=js&"
export * from "./GestioneAccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports